module.exports = __webpack_public_path__ + "imgs/CIF.303bb1e56643e90d62d440c4a0b3c7ce.png";